// extracted by mini-css-extract-plugin
export var dataCell = "_n2-2";
export var dataRow = "_n2-0";
export var headerRow = "_n2-1";